export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Boek.vue?vue&type=template&id=41241232&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Boek.vue?vue&type=template&id=41241232&
// module id = 339
// module chunks = 0